import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileStack, Settings, Activity, LogOut, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  const nav = [
    { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard, testId: "nav-dashboard" },
    { to: "/admin/applications", label: "Applications", icon: FileStack, testId: "nav-applications" },
    { to: "/admin/settings", label: "Settings", icon: Settings, testId: "nav-settings" },
    { to: "/admin/diagnostics", label: "Diagnostics", icon: Activity, testId: "nav-diagnostics" },
  ];

  return (
    <div className="min-h-screen flex bg-zinc-50">
      <aside className="w-64 shrink-0 border-r border-zinc-200 bg-white flex flex-col">
        <div className="p-6 border-b border-zinc-200">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-zinc-900 text-white flex items-center justify-center"><ShieldCheck size={16}/></div>
            <div>
              <p className="font-display font-black leading-none tracking-tighter">BCBF Admin</p>
              <p className="tech-label leading-none mt-0.5">Console</p>
            </div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to} to={n.to} data-testid={n.testId}
              className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2.5 rounded-md text-sm font-semibold transition-colors ${isActive ? "bg-zinc-900 text-white" : "text-zinc-700 hover:bg-zinc-100"}`}
            >
              <n.icon size={16} strokeWidth={2.25}/>{n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-zinc-200">
          <p className="text-xs text-zinc-500">Signed in as</p>
          <p className="text-sm font-semibold text-zinc-900 truncate">{user?.email}</p>
          <Button onClick={handleLogout} data-testid="admin-logout-btn" variant="outline" className="w-full mt-3 h-10 text-sm">
            <LogOut size={14} className="mr-2"/>Log out
          </Button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <Outlet/>
      </main>
    </div>
  );
}
